const customProductCartUpdate = (sections) => {
  let cartDrawerEl = document.querySelector("#CartDrawer");
  let html = new DOMParser()
    .parseFromString(sections["cart-drawer"], "text/html")
    .querySelector("#CartDrawer").innerHTML;
  cartDrawerEl.innerHTML = html;
  let bubbleEl = document.querySelector("#cart-icon-bubble");
  bubbleEl.innerHTML = sections["cart-icon-bubble"];
  document.querySelector("#cartDrawerContainer").classList.add("active");
};

for (let elToOpen of $(".expandableSection")) {
  elToOpen.addEventListener("click", function () {
    dropDownSection(elToOpen);
  });
}

function dropDownSection(elementToOpen) {
  var idSectionToOpen = elementToOpen.getAttribute("section-to-open");
  var sectionToOpen = document.querySelector(`#${idSectionToOpen}`);
  var elementHeight = document.querySelector(
    `#${idSectionToOpen} ul`
  ).scrollHeight;
  if (elementToOpen.getAttribute("aria-expanded") === "false") {
    sectionToOpen.style.maxHeight = elementHeight + "px";
    sectionToOpen.style.opacity = "1";

    elementToOpen.childNodes[3].style.rotate = "180deg";
    elementToOpen.setAttribute("aria-expanded", "true");
  } else {
    sectionToOpen.style.maxHeight = "0px";
    sectionToOpen.style.opacity = "0";

    elementToOpen.childNodes[3].style.rotate = "0deg";
    elementToOpen.setAttribute("aria-expanded", "false");
  }
}

const createFormData = (el) => {
  let vid = el.getAttribute("data-product-vid");
  let qty = document.querySelector("quantity-select select").value;
  let formData = {
    items: [
      {
        id: vid,
        quantity: qty || 1,
        form_type: "product",
      },
    ],
    sections: "cart-drawer,cart-icon-bubble",
  };
  
  let sellingPlanId = el.getAttribute("data-selling-plan");
  if (sellingPlanId) formData.items[0].selling_plan = sellingPlanId;
  return formData;
};

const subscriptionAtcEl = document.querySelectorAll(".subscription-atc");
for (let subAtc of subscriptionAtcEl) {
  subAtc.addEventListener("click", () => {
    subAtc.innerHTML = "Adding...";
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: createFormData(subAtc),
      success(e) {
        subAtc.innerHTML = "Added";
        customProductCartUpdate(e.sections);
      },
      error(e) {
        console.log(e);
      },
    });
  });
}
